import { saveAs } from "file-saver";

/**
 * Opens a new window to preview a file.
 * @param {string} fileUrl - URL of the file to preview.
 * @param {string} fileExtension - Extension of the file (e.g., .pdf, .png).
 */
export const previewFile = (fileUrl, fileExtension) => {
  const fileName = fileUrl.substring(fileUrl.lastIndexOf("/") + 1);

  const openPreviewWindow = (content) => {
    const previewWindow = window.open();
    if (previewWindow) {
      previewWindow.document.write(content);
      previewWindow.downloadFile = (url, name) => saveAs(url, name);
    } else {
      console.error("Failed to open preview window. Please check your browser settings.");
    }
  };

  if (fileExtension === ".pdf") {
    openPreviewWindow(`
      <div style="text-align: center; margin: 20px;">
        <iframe src="${fileUrl}" style="width: 100%; height: 90vh;" frameborder="0"></iframe>
        <br />
        <button onclick="window.downloadFile('${fileUrl}', '${fileName}')" style="padding: 10px 20px; background: #007bff; color: #fff; border: none; border-radius: 5px; cursor: pointer; font-family: Arial, sans-serif;">
          Download
        </button>
      </div>
    `);
  } else if ([".png", ".jpeg", ".jpg", ".gif",".webp"].includes(fileExtension)) {
    openPreviewWindow(`
      <div style="text-align: center; margin: 20px;">
        <img src="${fileUrl}" alt="Preview" style="max-width: 100%; margin-bottom: 20px;" />
        <br />
        <button onclick="window.downloadFile('${fileUrl}', '${fileName}')" style="padding: 10px 20px; background: #007bff; color: #fff; border: none; border-radius: 5px; cursor: pointer; font-family: Arial, sans-serif;">
          Download
        </button>
      </div>
    `);
  } else {
    console.error("Unsupported preview format");
  }
};

/**
 * Downloads files either by previewing or direct download.
 * @param {Array} files - Array of file paths to download or preview.
 * @param {string} baseFileUrl - Base URL to append to the file path.
 */
export const downloadFile = (files, baseFileUrl) => {
  files.forEach((file) => {
    const fileExtension = file.substring(file.lastIndexOf(".")).toLowerCase();

    const fileUrl = baseFileUrl + file;
    console.log('fileUrl',fileUrl)
    console.log('filest',fileExtension)
    if ([".png", ".jpeg", ".jpg", ".gif", ".pdf",".webp"].includes(fileExtension)) {
      previewFile(fileUrl, fileExtension);
    } else {
      saveAs(fileUrl);
    }
  });
};
